// stores/currentUser.js

import { defineStore } from 'pinia';
import { User } from '@/interfaces/User';
import { Asistencia } from '@/interfaces/Asistencia';
import { Asiento } from '@/interfaces/Asiento';
import { Clase } from '@/interfaces/Clase';
import { ProductCart } from '@/interfaces/ProductCart';
import { ref } from 'vue';

export function toPermissionNames(permissions: unknown): string[] {
  if (permissions == null) return [];

  const values: unknown[] = Array.isArray(permissions)
    ? permissions
    : typeof permissions === 'object'
      ? Object.values(permissions as Record<string, unknown>)
      : [];

  return values
    .map((p) => {
      if (typeof p === 'string') return p;
      if (p && typeof p === 'object' && 'name' in p) {
        const name = (p as { name: unknown }).name;
        return typeof name === 'string' ? name : null;
      }
      return null;
    })
    .filter((n): n is string => !!n);
}

export const currentUserStore = defineStore('currentUser', {
  state: () => ({
    user: null as User | null,
    asistencias: [] as Asistencia[],
    clases: [] as Clase[],
    cart: [] as ProductCart[],
    asientos: ref<Asiento[]>([]),
    redirectAfterLogin: null as string | null
  }),

  getters: {
    permissionNames: (state): string[] => toPermissionNames(state.user?.permissions)
  },

  actions:{
    update(myUser : User)
    {
        this.user = {
          ...myUser,
          permissions: toPermissionNames(myUser?.permissions)
        };
    }
  }
});